import {publish} from '../helpers/pubSub';
import {breakpoints} from '../helpers/utilities';
import {isRTL} from '@borngroup/born-utilities';

//Setup a bidirectional object for arrows,
//should ease selecting the right arrow direction acrosss carousels.
let RTL_ENABLED = isRTL(),
    ARROWS = {
        angle: {
            prev: RTL_ENABLED ? 'angle-right' : 'angle-left',
            next: RTL_ENABLED ? 'angle-left' : 'angle-right'
        }
    };

/**
 * Generates an arrow icon for the carousel
 */
function generateArrow(name = 'angle', direction, arrowClass = '', svgClass = '') {
    let isPrev = direction === 'prev',
        arrowIconName = ARROWS[name][direction];

    return `
        <button type="button" class="${arrowClass} slick-arrow slick-${direction}" aria-label="${isPrev ? window.SFRA.Resources.slidePrev : window.SFRA.Resources.slideNext}">
            <svg aria-hidden="true" focusable="false" class="icon ${svgClass}">
                <use xlink:href="#icon--${arrowIconName}"/>
            </svg>
        </button>
    `;
}

/**
 * These are generic settings for the multiple types of carousels/sliders.
 * These settings can be overridden by setting an ovrerride of the specific setting(s) on the data-slick attribute itself.
 */

//Settings for grid carousel: grid layout on bigger screes, carousel on smaller.
// export const gridCarousel = {
//     options: {
//         mobileFirst: true,
//         dots: true,
//         responsive: [
//             {
//                 breakpoint: 1,
//                 settings:
//                 {
//                     slidesToShow: 1,
//                     slidesToScroll: 1,
//                     centerMode: true,
//                     centerPadding: '60px'
//                 }
//             },
//             {
//                 breakpoint: 479,
//                 settings:
//                 {
//                     slidesToShow: 2,
//                     slidesToScroll: 2,
//                     centerMode: true,
//                     centerPadding: '60px'
//                 }
//             },
//             {
//                 breakpoint: 767,
//                 settings: 'unslick'
//             }
//         ]
//     }
// };

export const
    heroCarousel = {
        options: {
            dots: true,
            prevArrow: generateArrow('angle', 'prev'),
            nextArrow: generateArrow('angle', 'next'),
            responsive: [
                {
                    breakpoint: breakpoints.small,
                    settings: {
                        arrows: false
                    }
                }
            ]
        }
    },

    qvCarousel = {
        options: {
            arrows: true,
            prevArrow: generateArrow('angle', 'prev'),
            nextArrow: generateArrow('angle', 'next'),
            dots: true,
            infinite: false,
            responsive: [
                {
                    breakpoint: breakpoints.small + breakpoints.unit,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }
            ]
        }
    },

    pdpCarousel = {
        options: {
            arrows: true,
            dots: true,
            infinite: false,
            prevArrow: generateArrow('angle', 'prev'),
            nextArrow: generateArrow('angle', 'next'),
            mobileFirst: true,
            reslickResponsively: true,
            accessibility: true,
            responsive: [
                {
                    breakpoint: breakpoints.small,
                    settings: 'unslick',
                    accessibility: true
                }
            ]
        },
        methods: {
            beforeChange: publish.bind(this, 'productZoom:slideChange')
        }
    },

    zoomCarousel = {
        options: {
            slidesToShow: 1,
            slidesToScroll: 1,
            accessibility: true,
            draggable: false,
            infinite: true,
            speed: 0,
            prevArrow: generateArrow('angle', 'prev', 'product-zoom__arrow product-zoom__arrow--prev'),
            nextArrow: generateArrow('angle', 'next', 'product-zoom__arrow product-zoom__arrow--next'),
            responsive: [
                {
                    breakpoint: breakpoints.small,
                    settings: {
                        draggable: true
                    }
                }
            ]
        },
        methods: {
            beforeChange: publish.bind(this, 'productZoom:slideChange')
        }
    },

    productListCarousel = {
        options: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
            prevArrow: generateArrow('angle', 'prev'),
            nextArrow: generateArrow('angle', 'next'),
            responsive: [
                {
                    breakpoint: breakpoints.small,
                    settings: {
                        arrows: false,
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        }
    },

    flexibleCarousel = {
        options: {
            slidesToShow: 3,
            slidesToScroll: 3,
            dots: true,
            infinite: true,
            adaptiveHeight: false,
            prevArrow: generateArrow('angle', 'prev'),
            nextArrow: generateArrow('angle', 'next')
        }
    },

    mobile2ColCarousel = {
        options: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: true,
            infinite: false,
            adaptiveHeight: false,
            mobileFirst: true,
            prevArrow: generateArrow('angle', 'prev'),
            nextArrow: generateArrow('angle', 'next'),
            responsive: [
                {
                    breakpoint: 767,
                    settings: 'unslick'
                }
            ]
        }
    },

    mobile4ColCarousel = {
        options: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: true,
            infinite: false,
            adaptiveHeight: true,
            mobileFirst: true,
            prevArrow: generateArrow('angle', 'prev'),
            nextArrow: generateArrow('angle', 'next'),
            responsive: [
                {
                    breakpoint: 767,
                    settings: 'unslick'
                }
            ]
        }
    },

    headerFlyoutCarousel = {
        options: {
            slidesToShow: 6,
            slidesToScroll: 6,
            arrows: true,
            infinite: false,
            prevArrow: generateArrow('angle', 'prev'),
            nextArrow: generateArrow('angle', 'next'),
            responsive: [
                {
                    breakpoint: breakpoints.medium,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                    }
                },
                {
                    breakpoint: breakpoints.small,
                    settings: 'unslick'
                }
            ]
        }
    },

    headerPromoBannerCarousel = {
        options: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            arrows: true,
            dots: false,
            adaptiveHeight: false,
            prevArrow: generateArrow('angle', 'prev'),
            nextArrow: generateArrow('angle', 'next')
        }
    },

    shopTheLookCarousel = {
        options: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            arrows: true,
            dots: true,
            prevArrow: generateArrow('angle', 'prev'),
            nextArrow: generateArrow('angle', 'next')
        }
    };
